import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-598a5f7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sticky-top p-0 m-0" }
const _hoisted_2 = {
  id: "top-bar",
  class: "container-fluid p-0 m-0"
}
const _hoisted_3 = { class: "row m-0 p-0" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = {
  id: "top-logo",
  class: "p-0 m-0"
}
const _hoisted_6 = { id: "overRun" }
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined d-table-cell align-middle" }, " menu ", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  id: "menu",
  class: "container-fluid p-0 m-0"
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "list-group text-light text-start mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createElementVNode("h1", {
                class: "m-0 text-light",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.home && _ctx.home(...args)))
              }, "OverRun")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.userButton)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-primary centered-button border-0 float-end d-table",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
              }, _hoisted_9))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("ul", _hoisted_13, [
            _createElementVNode("li", {
              class: "list-group-item",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.settings && _ctx.settings(...args)))
            }, "Paramètres"),
            _createElementVNode("li", {
              class: "list-group-item",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.disconnect && _ctx.disconnect(...args)))
            }, "Déconnexion")
          ])
        ])
      ])
    ], 512), [
      [_vShow, _ctx.showMenu]
    ])
  ]))
}